import { render, staticRenderFns } from "./dash-table.vue?vue&type=template&id=9cab7be2"
import script from "./dash-table.vue?vue&type=script&lang=ts"
export * from "./dash-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports